import gql from 'graphql-tag';

export default gql`
  mutation leaveChannel($userGroupId: UUID!) {
    leaveChannel(userGroupRoleId: $userGroupId)
  }
`;
